/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_Prep_Type_Switch_TitleInputs */



/**
* | output |
* | --- |
* | "Switch to {name}?" |
*
* @param {Meeting_Prep_Type_Switch_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_type_switch_title = /** @type {((inputs: Meeting_Prep_Type_Switch_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Type_Switch_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Wisselen naar ${i?.name}?`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Passer à ${i?.name} ?`)
	return /** @type {LocalizedString} */ (`Switch to ${i?.name}?`)
});